"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollElementIntoView = exports.scrollElementToTopOfViewportIfNotVisible = exports.closest = exports.matches = exports.injectScriptText = exports.injectScriptSrc = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var injectScriptSrc = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(src) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var script = document.createElement("script");
              script.onload = resolve;
              script.onerror = reject;
              script.src = src;
              document.body.appendChild(script);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function injectScriptSrc(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.injectScriptSrc = injectScriptSrc;

var injectScriptText = function injectScriptText(textContent) {
  var script = document.createElement("script");
  script.textContent = textContent;
  document.body.appendChild(script);
};

exports.injectScriptText = injectScriptText;

var matches = function matches(element, selector) {
  return element.matches ? element.matches(selector) : element.msMatchesSelector(selector);
};

exports.matches = matches;

var closest = function closest(element, selector) {
  if (element.closest) {
    return element.closest(selector);
  } else {
    var el = element;

    do {
      if (matches(el, selector)) {
        return el;
      }

      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  }
};

exports.closest = closest;

var getOffsetTop = function getOffsetTop(element) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return element ? getOffsetTop(element.offsetParent, top + element.offsetTop) : top;
};

var scrollElementToTopOfViewportIfNotVisible = function scrollElementToTopOfViewportIfNotVisible(element) {
  var DISTANCE_FROM_VIEWPORT_EDGE = 250;
  var isAboveVisibleViewport = element && getOffsetTop(element) < window.pageYOffset + DISTANCE_FROM_VIEWPORT_EDGE;
  var isBelowVisibleViewport = element && getOffsetTop(element) > window.pageYOffset + window.innerHeight - DISTANCE_FROM_VIEWPORT_EDGE;

  if (isAboveVisibleViewport || isBelowVisibleViewport) {
    window.scrollTo({
      top: element.offsetTop - DISTANCE_FROM_VIEWPORT_EDGE,
      behavior: "smooth"
    });
  }
};

exports.scrollElementToTopOfViewportIfNotVisible = scrollElementToTopOfViewportIfNotVisible;

var scrollElementIntoView = function scrollElementIntoView(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$margin = options.margin,
      margin = _options$margin === void 0 ? 0 : _options$margin;
  var offsetHeight = element.offsetHeight;
  var offsetTop = getOffsetTop(element);
  var _window = window,
      pageYOffset = _window.pageYOffset,
      innerHeight = _window.innerHeight;
  var scrollPosMin = offsetTop + offsetHeight - innerHeight + margin;
  var scrollPosMax = offsetTop - margin;
  var top = scrollPosMin <= scrollPosMax ? Math.max(Math.min(pageYOffset, scrollPosMax), scrollPosMin) : scrollPosMax;

  if (top !== pageYOffset) {
    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  }
};

exports.scrollElementIntoView = scrollElementIntoView;